
//#region DefaultConditions

/** or default condition */
export const orCondition: AdvancedFilterCondition = {
    uid: "orCondition",
    label: "OU", // TODO i18n
    placeholder: "Ou", // TODO i18n
    priority: 2,
    comparator: (value: boolean, valueToCompare: boolean): boolean => value || valueToCompare
};

/** and default condition */
export const andCondition: AdvancedFilterCondition = {
    uid: "andCondition",
    label: "ET", // TODO i18n
    placeholder: "Et", // TODO i18n
    priority: 1,
    comparator: (value: boolean, valueToCompare: boolean): boolean => value && valueToCompare
};

/** Default condition list */
export const ADVANCED_FILTER_DEFAULT_CONDITIONS = [orCondition, andCondition] as const;

//#endregion

export type ConditionUid = string;
/** Custom condition */
export interface AdvancedFilterCondition {
    uid: ConditionUid;
    label: string;
    placeholder?: string;
    /** priority over other conditions (and before or) should be >=1 */
    priority: number;
    /** condition function */
    comparator(value: boolean, valueToCompare: boolean): boolean;
}